import React from 'react';

export interface SyncStateDisplay {
  workspaceId: string;
  status: 'disconnected' | 'connecting' | 'connected' | 'error';
  error?: string;
  presenceCount?: number;
}

export interface CollaborationBarProps {
  syncState?: SyncStateDisplay;
}

const STATUS_CONFIG = {
  connected: { color: 'bg-green-500', label: 'Connected' },
  connecting: { color: 'bg-yellow-500', label: 'Reconnecting...' },
  disconnected: { color: 'bg-red-500', label: 'Disconnected' },
  error: { color: 'bg-red-500', label: 'Disconnected' },
} as const;

export function CollaborationBar({ syncState }: CollaborationBarProps) {
  if (!syncState) return null;

  const config = STATUS_CONFIG[syncState.status];

  return (
    <div className="flex items-center justify-between px-4 py-1 bg-muted/50 border-b border-border text-xs text-muted-foreground">
      <div className="flex items-center gap-2">
        <span className={`w-2 h-2 rounded-full ${config.color}`} />
        <span>{config.label}</span>
      </div>
      {syncState.status === 'connected' && syncState.presenceCount !== undefined && (
        <span>{syncState.presenceCount} online</span>
      )}
    </div>
  );
}
